import React from 'react';
import { ShieldExclamationIcon } from '@heroicons/react/24/outline';
import { TWButton, IconBadge } from '../../../../components/ui';
import { formatCurrency } from '../../../../utils/baseUtils';

const STATUS_META = {
  0: {
    label: 'Pending',
    cls: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300',
  },
  1: {
    label: 'Approved',
    cls: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300',
  },
  2: {
    label: 'Rejected',
    cls: 'bg-rose-100 text-rose-800 dark:bg-rose-900/30 dark:text-rose-300',
  },
};

const RefundApprovalCard = ({ approval, approveLoading, onApprove }) => {
  if (!approval) return null;
  const meta = STATUS_META[approval.status] || STATUS_META[0];

  return (
    <section
      className="reveal flex items-start gap-4 rounded-md border border-rose-200 bg-rose-50 p-5 dark:border-rose-900/50 dark:bg-rose-900/15"
      aria-label="Refund approval"
    >
      <IconBadge icon={ShieldExclamationIcon} tone="rose" size="md" />
      <div className="min-w-0 flex-1">
        <h4 className="text-sm font-bold text-rose-900 dark:text-rose-200">
          Refund Approval Required
        </h4>
        {approval.reason && (
          <p className="mt-1 text-sm text-rose-700 dark:text-rose-300">
            {approval.reason}
          </p>
        )}
        <div className="mt-3 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm">
          <div>
            <span className="text-rose-700/80 dark:text-rose-300/80">
              Amount:{' '}
            </span>
            <span className="font-bold tabular-nums text-rose-900 dark:text-rose-200">
              {formatCurrency(approval.amount)}
            </span>
          </div>
          <div>
            <span className="text-rose-700/80 dark:text-rose-300/80">
              Status:{' '}
            </span>
            <span
              className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold ${meta.cls}`}
            >
              {meta.label}
            </span>
          </div>
        </div>
        {approval.status === 0 && (
          <div className="mt-4">
            <TWButton
              variant="danger"
              label="Approve Refund"
              loading={approveLoading}
              onClick={onApprove}
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default RefundApprovalCard;
